// tslint:disable:no-bitwise
import * as Hash from "object-hash";
var stringSorter = function (a, b) { return b.charCodeAt(0) - a.charCodeAt(0); };
var UtilHash = /** @class */ (function () {
    function UtilHash() {
        this.simpleHash = function (object) {
            var str = Object.keys(object)
                .sort(stringSorter)
                .reduce(function (acc, key) { return acc + key + object[key]; }, "");
            var hash = 0;
            for (var i = 0; i < str.length; i++) {
                var character = str.charCodeAt(i);
                hash = (hash << 5) - hash + character;
                hash = hash & hash; // Convert to 32bit integer
            }
            return hash;
        };
        this.md5Hash = function (object) {
            return Hash(object, { algorithm: "md5", encoding: "base64" });
        };
    }
    return UtilHash;
}());
export var utilHash = new UtilHash();



//////////////////
// WEBPACK FOOTER
// ./src/utils/utilHash.ts
// module id = 910
// module chunks = 3